<template>
	<div id="pageRoot">

		<span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
		<p>Lee con atención este texto.</p>
		</span>
		<span class="normalTheme pageInstruction" style="left: 55px; top: 95px;">
		<p>Tacha las palabras que esten repetidas.</p>
		</span>

		<p class="textBase appearAnimationB" id="crossingText" style="z-index: 6" ref="crossingText">
		"Existen aproximadamente 800 razas de perros. Las razas de perros varían en tamaño, fisionomía y temperamento. Las razas de perros también varían en color y tipo de pelo. La raza más pequeña es el chihuahua."
		</p>

		<span class="normalTheme pageInstruction" style="left: 55px; top: 480px;">
		<p>Entre todos escriban el texto en el pizarrón, dictándole al maestro.</p>
		</span>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<span class="footer-page footer-listen"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#crossingText
{
position: absolute;
width: 859px;
height: 210px;
left: 78px;
top: 190px;

font-size: 33px;
line-height: 45px;
text-transform: uppercase;

cursor: default;
color: #2BB673;
}
#text04
{
position: absolute;
width: 472px;
height: 35px;
left: 78px;
top: 546px;

font-size: 24px;
line-height: 33px;

color: #000000;
}
#text05
{
position: absolute;
width: 640px;
height: 35px;
left: 78px;
top: 616px;

font-size: 24px;
line-height: 33px;

color: #000000;
}
</style>
<script>
	export default {
		data() {
			return {
				videos: ["p92/V132.mp4"]
			};
		},

		methods:{
		dbId(name, option){
			return `${this.$parent.pageID()}-${name}-${option}`
		},
		async loadOption(name, option) {
			var id = this.dbId(name, option);

			var value = await this.$db.options.get({
			id: id,
			}).catch(function(error){
			console.log("error getting option" + error);
			});
			if (value === undefined) return;
			console.log(value);

			if (value.option){
				this.crossWord(option);
			}

			console.log("option loaded: " + id + ", " + value.option);
		},
		saveOption(name, option) {
			var id = this.dbId(name, option);

			var word = document.getElementById(option);
			var c = " highlight"

			var value = word.className.includes(c);

			this.$db.options.put({
				id: id,
				option: value
			}).catch(function(error){
				console.log("error saving option" + error);
			});

			console.log("option saved: " + id + ", " + value);
		},
		setupCrossText(t){
				var words = t.innerHTML.split( " " );
				this.$refs["crossingText"].innerHTML="";
				for (var i = 0; i < words.length; i++) {
				this.$refs["crossingText"].innerHTML += '<span class="crossable" id="crt' + i + '">' + words[i] + "</span>" + " ";
				console.log(words[i]);
				}
				document.querySelectorAll('.crossable').forEach(item => {
					item.addEventListener('click', () => {
					this.crossWord(item.id);
					this.saveOption('crossingText', item.id);
					})
				})
			},
		crossWord(id){
				var word = document.getElementById(id);
				var c = " highlight"
				if (word.className.includes(c)) {
					word.className = word.className.replace(c, "")
				}
				else
				{
					word.className += c;
				}
			}
		},
		mounted(){
			this.setupCrossText(this.$refs["crossingText"]);
			document.querySelectorAll('.crossable').forEach(item => {
				this.loadOption('crossingText', item.id);
			})
		}
	}
</script>